import React from "react";
import { Dropdown } from "react-bootstrap";

class Header extends React.Component {

    render() {
        let user = JSON.parse(localStorage.getItem("user"));
        return (
            <div>
                    <header className="header fixed-top clearfix">

                        <div className="brand">

                            <a className="logo">
                                <img src="https://www.vidyamandir.com/assets/images/vmc_logo.png" alt="VidyaMandir" style={{ width: '93%' }} />
                            </a>
                            <div className="sidebar-toggle-box">
                                <div className="fa fa-bars"></div>
                            </div>
                        </div>

                        <div className="top-nav clearfix">
                            <div className="nav pull-right top-menu">
                                <Dropdown>
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        <i
                                            className="fa fa-user"
                                            style={{ paddingLeft: "10%", paddingRight: "10%" }}></i>
                                        {user.data.username}
                                        <b className="caret"></b>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="/admin/login">
                                            <span style={{ padding: "5px" }}>Logout </span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </header>
            </div>
        );
    }
}

export default Header;
